module.exports = __webpack_public_path__ + "img/fire-white.9f3ccdf4.svg";